/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResultOfApiAuditVm } from '../models/custom-result-of-api-audit-vm';
import { CustomResultOfLoginAuditVm } from '../models/custom-result-of-login-audit-vm';
import { CustomResultOfRuleAuditVm } from '../models/custom-result-of-rule-audit-vm';
import { CustomResultOfSuperAdminAuditVm } from '../models/custom-result-of-super-admin-audit-vm';
import { superAdminsGetApiAuditsWithPagination } from '../fn/super-admins/super-admins-get-api-audits-with-pagination';
import { SuperAdminsGetApiAuditsWithPagination$Params } from '../fn/super-admins/super-admins-get-api-audits-with-pagination';
import { superAdminsGetLoginAuditWithPagination } from '../fn/super-admins/super-admins-get-login-audit-with-pagination';
import { SuperAdminsGetLoginAuditWithPagination$Params } from '../fn/super-admins/super-admins-get-login-audit-with-pagination';
import { superAdminsGetRulesAuditWithPagination } from '../fn/super-admins/super-admins-get-rules-audit-with-pagination';
import { SuperAdminsGetRulesAuditWithPagination$Params } from '../fn/super-admins/super-admins-get-rules-audit-with-pagination';
import { superAdminsGetSuperAdminAuditsWithPagination } from '../fn/super-admins/super-admins-get-super-admin-audits-with-pagination';
import { SuperAdminsGetSuperAdminAuditsWithPagination$Params } from '../fn/super-admins/super-admins-get-super-admin-audits-with-pagination';

@Injectable({ providedIn: 'root' })
export class SuperAdminsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `superAdminsGetRulesAuditWithPagination()` */
  static readonly SuperAdminsGetRulesAuditWithPaginationPath = '/SuperAdmins/GetRulesAuditWithPagination';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superAdminsGetRulesAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superAdminsGetRulesAuditWithPagination$Response(params: SuperAdminsGetRulesAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfRuleAuditVm>> {
    return superAdminsGetRulesAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superAdminsGetRulesAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superAdminsGetRulesAuditWithPagination(params: SuperAdminsGetRulesAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfRuleAuditVm> {
    return this.superAdminsGetRulesAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfRuleAuditVm>): CustomResultOfRuleAuditVm => r.body)
    );
  }

  /** Path part for operation `superAdminsGetApiAuditsWithPagination()` */
  static readonly SuperAdminsGetApiAuditsWithPaginationPath = '/SuperAdmins/GetApiAuditsWithPagination';

  /**
   * Only for super admin, Get all api logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superAdminsGetApiAuditsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superAdminsGetApiAuditsWithPagination$Response(params: SuperAdminsGetApiAuditsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfApiAuditVm>> {
    return superAdminsGetApiAuditsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all api logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superAdminsGetApiAuditsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superAdminsGetApiAuditsWithPagination(params: SuperAdminsGetApiAuditsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfApiAuditVm> {
    return this.superAdminsGetApiAuditsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfApiAuditVm>): CustomResultOfApiAuditVm => r.body)
    );
  }

  /** Path part for operation `superAdminsGetLoginAuditWithPagination()` */
  static readonly SuperAdminsGetLoginAuditWithPaginationPath = '/SuperAdmins/GetLoginAuditWithPagination';

  /**
   * Only for super admin, Get all api logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superAdminsGetLoginAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superAdminsGetLoginAuditWithPagination$Response(params: SuperAdminsGetLoginAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfLoginAuditVm>> {
    return superAdminsGetLoginAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all api logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superAdminsGetLoginAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superAdminsGetLoginAuditWithPagination(params: SuperAdminsGetLoginAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfLoginAuditVm> {
    return this.superAdminsGetLoginAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfLoginAuditVm>): CustomResultOfLoginAuditVm => r.body)
    );
  }

  /** Path part for operation `superAdminsGetSuperAdminAuditsWithPagination()` */
  static readonly SuperAdminsGetSuperAdminAuditsWithPaginationPath = '/SuperAdmins/GetSuperAdminAuditsWithPagination';

  /**
   * Only for super admin, Get all superadmin logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superAdminsGetSuperAdminAuditsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superAdminsGetSuperAdminAuditsWithPagination$Response(params: SuperAdminsGetSuperAdminAuditsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfSuperAdminAuditVm>> {
    return superAdminsGetSuperAdminAuditsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all superadmin logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superAdminsGetSuperAdminAuditsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superAdminsGetSuperAdminAuditsWithPagination(params: SuperAdminsGetSuperAdminAuditsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfSuperAdminAuditVm> {
    return this.superAdminsGetSuperAdminAuditsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfSuperAdminAuditVm>): CustomResultOfSuperAdminAuditVm => r.body)
    );
  }

}
